export default __webpack_public_path__ + "static/210521_妲絲刷關活動熱更預告_tc-29de7e83ec281efb18299122f4998317.png";